import { AlertTriangle, Ear, Loader2, RotateCw } from "lucide-react";

const COPY = {
  bad: ["Your room is too noisy for accurate scoring", "Background noise (voices, TV, fans, traffic) will be picked up with your answers and can lower your speaking scores. Move somewhere quieter, close doors and windows, or use a headset mic."],
  warn: ["Some background noise detected", "Scoring should still work, but a quieter spot or a headset mic will give more accurate speaking scores."],
};

export const QuietRoomCheck = ({ state, level, noise, onRetry, onContinue }) => {
  if (state === "measuring") return (
    <div data-testid="quiet-room-measuring" className="rounded-xl border border-indigo-200 bg-indigo-50 p-4">
      <p className="flex items-center gap-2 text-sm font-semibold text-indigo-900"><Ear className="h-4 w-4" />Quiet room check: stay silent for 3 seconds…<Loader2 className="h-4 w-4 animate-spin" /></p>
      <div className="mt-3 h-2 overflow-hidden rounded-full bg-indigo-100"><div data-testid="quiet-room-level" className={`h-full transition-[width] duration-75 ${level > 18 ? "bg-rose-500" : level > 7 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${level}%` }} /></div>
    </div>
  );
  const [title, text] = COPY[state] || [];
  if (!title) return null;
  const bad = state === "bad";
  return (
    <div data-testid="quiet-room-warning" data-level={state} className={`rounded-xl border p-4 ${bad ? "border-rose-200 bg-rose-50 text-rose-900" : "border-amber-200 bg-amber-50 text-amber-900"}`}>
      <p className="flex items-center gap-2 text-sm font-bold"><AlertTriangle className="h-4 w-4" />{title}</p>
      <p className="mt-1 text-xs leading-relaxed">{text}</p>
      <p data-testid="quiet-room-noise-value" className="mt-1 font-mono text-[11px] opacity-70">Noise level {Math.round(noise * 1000)} (quiet is under {Math.round(0.012 * 1000)})</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid="quiet-room-retry-btn" onClick={onRetry} className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-4 py-2 text-xs font-bold text-white hover:bg-slate-700"><RotateCw className="h-3.5 w-3.5" />Check again</button>
        <button data-testid="quiet-room-continue-btn" onClick={onContinue} className="rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50">Continue anyway</button>
      </div>
    </div>
  );
};
